(function() {
    const CURRENT_YEAR = new Date().getFullYear();
    
    window.DateSelectors = {
        updateDateSelectors: updateDateSelectors,
        populateMonths: populateMonths,
        populateDays: populateDays,
        init: initDateSelectors,
        getCurrentYear: () => CURRENT_YEAR
    };

    function populateMonths(monthSelect) {
        const userLocale = navigator.language || 'en-GB';
        const locale = userLocale.startsWith('en-GB') ? 'en-GB' : 'en-US';
        
        monthSelect.innerHTML = '<option value="" disabled selected>Select Month</option>';
        
        const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
        const currentYear = new Date().getFullYear();
        
        for (let monthIndex = 1; monthIndex <= 12; monthIndex++) {
            const option = document.createElement('option');
            option.value = monthIndex;
            const sampleDate = new Date(currentYear, monthIndex - 1, 1);
            option.textContent = monthFormatter.format(sampleDate);
            monthSelect.appendChild(option);
        }
    }

    function getDaysInMonth(year, month) {
        return new Date(year, month, 0).getDate();
    }

    function populateDays(daySelect, monthValue, desiredDay = null) {
        const selectedMonth = parseInt(monthValue, 10);
        if (isNaN(selectedMonth)) {
            daySelect.innerHTML = '<option value="" disabled selected>Select Day</option>';
            return;
        }

        const daysInMonth = getDaysInMonth(CURRENT_YEAR, selectedMonth);
        const targetDay = desiredDay !== null && !isNaN(desiredDay) 
            ? Math.min(Math.max(1, desiredDay), daysInMonth) 
            : 1;

        daySelect.innerHTML = '<option value="" disabled>Select Day</option>';
        for (let day = 1; day <= daysInMonth; day++) {
            const option = document.createElement('option');
            option.value = day;
            option.textContent = day;
            if (day === targetDay) {
                option.selected = true;
            }
            daySelect.appendChild(option);
        }
    }

    function updateDateSelectors(month, day) {        
        const monthSelect = document.getElementById('month-select');
        const daySelect = document.getElementById('day-select');
        
        if (!monthSelect || !daySelect) return;
        
        const oldMonthOnChange = monthSelect.onchange || null;
        const oldDayOnChange = daySelect.onchange || null;
        monthSelect.onchange = null;
        daySelect.onchange = null;

        try {
            monthSelect.value = '';
            if (!month || !day) {
                daySelect.innerHTML = '<option value="" disabled selected>Select Day</option>';
                return;
            }

            monthSelect.value = String(month);
            const daysInMonth = getDaysInMonth(CURRENT_YEAR, month);
            const targetDay = Math.min(Math.max(1, parseInt(day)), daysInMonth);

            daySelect.innerHTML = '<option value="" disabled>Select Day</option>';
            for (let d = 1; d <= daysInMonth; d++) {
                const option = document.createElement('option');
                option.value = String(d);
                option.textContent = d;
                daySelect.appendChild(option);
            }

            daySelect.value = String(targetDay);
            if (daySelect.options[targetDay]) {
                daySelect.options[targetDay].selected = true;
            }
        } finally {
            monthSelect.onchange = oldMonthOnChange;
            daySelect.onchange = oldDayOnChange;

            setTimeout(() => {
                monthSelect.dispatchEvent(new Event('change', { bubbles: true }));
                daySelect.dispatchEvent(new Event('change', { bubbles: true }));
            }, 0);
        }
    }

    function initDateSelectors() {
        const monthSelect = document.getElementById('month-select');
        const daySelect = document.getElementById('day-select');
        
        if (!monthSelect || !daySelect) return;

        populateMonths(monthSelect);
        populateDays(daySelect, '', 1);

        monthSelect.addEventListener('change', () => {
            const currentDay = parseInt(daySelect.value) || 1;
            populateDays(daySelect, monthSelect.value, currentDay);
        });
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDateSelectors);
    } else {
        initDateSelectors();
    }
})();
